import { render } from "./IconChevronLeftLine.vue?vue&type=template&id=fb58bd66"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__